import React from 'react';
import PropTypes from 'prop-types';

import Button from "../Global/Buttons/Button";
import NewFolderButton from "./NewFolderButton";

const FolderHeaderHome = ({ onNewFolderClick, title, subtitle }) => (
  <div className="folder-header">
    <div className="border-bottom-1 border-color-grey--light d-flex flex-column align-items-center text-center p-x-3 p-y-4">
      <span className="like-small color-grey text-uppercase fw-medium m-b-1 letter-spacing-s">Home</span>
      <h2 className="like-h4 fw-medium m-b-0">{ title }</h2>
      <ul className="inline-list-new inline-list-new--s m-t-3">
        <li>
          <Button size="s" faux disabled>{ subtitle }</Button>
        </li>
      </ul>
    </div>

    <div className="d-flex align-items-center justify-content-space-between border-bottom-1 border-color-grey--light">
      <NewFolderButton onClick={onNewFolderClick} />
    </div>
  </div>
);

FolderHeaderHome.propTypes = {
    onNewFolderClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
};

export default FolderHeaderHome;



// WEBPACK FOOTER //
// ./library/app/components/Folders/FolderHeaderHome.js